




































/* eslint-disable no-unused-expressions */
import { ref, watch, onMounted } from '@vue/composition-api'
// @ts-ignore
import prettier from 'prettier/standalone'
// @ts-ignore
import parserBabylon from 'prettier/parser-babylon'
import { useStoragePlain } from '@vueuse/core'
import { Compiler, Program, Token, SourceLocation, createContext } from '../../compiler/src'
import { printError } from '../../cli/src/error-log'
import examples from '../../examples'

export default {
  name: 'App',
  setup() {
    const code = useStoragePlain('wenyan-parser-viewer-code', '')
    const compiled = ref('')
    const example = useStoragePlain('wenyan-parser-viewer-example', 'helloworld')
    const tab = ref(0)
    const ast = ref<Program>([])
    const tokens = ref<Token[]>([])
    const error = ref<Error | null>(null)
    const cm1 = ref<Vue>(null)
    const cm2 = ref<Vue>(null)
    const errorText = ref('')
    let textMarker: any
    let errorMarker: any

    const run = () => {
      console.clear()
      // @ts-ignore
      errorMarker?.clear()

      const compiler = new Compiler(
        createContext(code.value),
        {
          sourcemap: true,
        })
      try {
        // @ts-ignore
        window.context = compiler.context
        compiler.run()
        tokens.value = compiler.tokens
        ast.value = compiler.ast
        // ast.value = shake(compiler.ast, [{ type: 'Identifier', name: '勾股求弦' }])
        compiled.value = prettier.format(compiler.compiled, {
          parser: 'babel',
          plugins: [parserBabylon],
        })

        error.value = null
        errorText.value = ''
      }
      catch (e) {
        tokens.value = compiler.tokens || ['ERROR'] as any
        ast.value = compiler.ast || { message: 'ERROR' } as any
        compiled.value = `// ERROR: ${e}`
        error.value = e
        errorText.value = ''

        if (e.loc) {
          // @ts-ignore
          errorMarker = cm1.value?.codemirror.markText({
            line: e.loc.start.line - 1,
            ch: e.loc.start.column,
          }, {
            line: e.loc.end.line - 1,
            ch: e.loc.end.column,
          }, {
            className: 'token-error',
          })
        }

        printError(e, (msg: any = '') => errorText.value += `${msg}\n`)
      }
    }

    watch(code, run, { lazy: true })

    watch(example, () => {
      code.value = examples[example.value as any]?.code || ''
    }, { lazy: true })

    onMounted(() => {
      // @ts-ignore
      cm1.value.codemirror.setSize(null, '100%')
      // @ts-ignore
      cm2.value.codemirror.setSize(null, '100%')

      run()
    })

    const highlight = ({ start, end }: SourceLocation) => {
      // @ts-ignore
      textMarker?.clear()
      // @ts-ignore
      textMarker = cm1.value.codemirror.markText({
        line: start.line - 1,
        ch: start.column,
      }, {
        line: end.line - 1,
        ch: end.column,
      }, {
        className: 'token-highlighted',
      })
    }

    const clearHighlight = () => {
      // @ts-ignore
      textMarker?.clear()
    }

    return {
      code,
      compiled,
      ast,
      tokens,
      tab,
      error,
      errorText,
      cm1,
      cm2,
      example,
      examples,
      highlight,
      clearHighlight,
    }
  },
}
